export default __webpack_public_path__ + "static/people_01-8f13735b1017510e498d3bb036b6bc84.png";